import { shallowEqual, useSelector } from 'react-redux';

import { getPayTypeForCountryCode } from 'src/app/utils/country';
import type AppState from 'src/types/appState';
import type { PayType } from 'src/types/salaryTypes';

export const usePayType = (): PayType => {
  const { jobLocationCountry, hirerNation, payType } = useSelector(
    (state: AppState) => ({
      jobLocationCountry: state.session.jobLocationCountry,
      hirerNation: state.session.hirerAccount.nation,
      payType: state.formData.payType as PayType,
    }),
    shallowEqual,
  );

  const hasExistingPayType = Boolean(payType) && payType.length > 0;
  const calculatedPayType = hasExistingPayType
    ? payType
    : getPayTypeForCountryCode(jobLocationCountry || hirerNation);

  return calculatedPayType;
};
